export default __webpack_public_path__ + "static/media/1 (8).ce1aef02.png";